import React, { useEffect, useState, useRef } from "react";
import {
  Edit,
  X,
  CheckCircle,
  Circle,
  AArrowDown,
  XIcon,
  UploadIcon,
} from "lucide-react";
import "./Css/Reservations.css";
import "./Css/aplicationform.css";
import Header from "./Header.js";
import Loader from "./Loader.js";
import "react-datepicker/dist/react-datepicker.css";
import GreyArrow from "../assets/greyLeftAr.png";
import DatePicker from "react-datepicker";
import SignatureCanvas from "react-signature-canvas";
import { useLocation } from "react-router-dom";
import {
  server_post_data,
  create_walkIn_booking_edit,
  get_booking_data,
  APL_LINK,
  upload_image_to_folder,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleAlphabetsNumberWithoutSpaceChange,
  handleError,
  handleNumbersChange,
  handleSuccessSession,
  goBack,
  validateDrivingLicense,
} from "../CommonJquery/CommonJquery.js";
import { toast } from "react-toastify";
import { number } from "prop-types";
import { retrieveData, storeData } from "../LocalConnection/LocalConnection.js";
import { useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import Breadcrumb from "../CommonJquery/Breadcrumb.js";
let click_type = 0;
function EditApplicationFormPage() {
  const { id } = useParams();
  const lastValidPaid = useRef("");
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const location = useLocation();
  const data = location.state;
  const carData = data.option.car_data[0];
  const customer_id = retrieveData("customer_id");
  const customer_name = retrieveData("customer_name");
  const customer_email = retrieveData("customer_email");
  const dob_date = retrieveData("dob_date");
  const driving_expiration_date = retrieveData("driving_expiration_date");
  const maxDob = new Date();
  const [agreed, setAgreed] = useState(false);
  const [numberOfDays, setNumberOfDays] = useState(null);
  const [totalCost, setTotalCost] = useState(null);
  maxDob.setFullYear(maxDob.getFullYear() - 16);
  const [step, setStep] = useState(1);
  const [getApplicationdata, setgetApplicationdata] = useState([]);
  const [pickupdate, setpickupdate] = useState([]);
  const [errors, setErrors] = useState({});
  const [dropdate, setdropdate] = useState([]);
  const [selectedcarprice, setselectedcarprice] = useState("");
  const [selectedcarid, setselectedcarid] = useState("");
  const [finalPrice, setFinalPrice] = useState(null);
  const [drivingLicenseFileName, setDrivingLicenseFileName] =
    useState("No file chosen");
  const [mvrFileName, setMvrFileName] = useState("No file chosen");
  const present_map_address = retrieveData("present_map_address");
  const nameParts = customer_name.trim().split(" ");
  const firstName = nameParts.length > 0 ? nameParts[0] : "";
  const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
  const [SignImg, SetSignImg] = useState();
  const [DLImg, SetDLImg] = useState();
  const [MvrUrl, SetMvrUrl] = useState();
  const [surcharges, Setsurcharges] = useState();
  const [deposit, Setdeposit] = useState(0);
  const [depositfirst, Setdepositfirst] = useState();
  const [paiddeposit, Setpaiddeposit] = useState("");
  const [paiddepositFirst, SetpaiddepositFirst] = useState(0);
  const [duedeposit, Setduedeposit] = useState(0);
  const [uploadedDamageImages, setUploadedDamageImages] = useState([]);
  // useEffect(() => {
  //   if (deposit > paiddeposit) {
  //     const due = parseInt(deposit) - parseInt(paiddeposit);
  //     Setduedeposit(due);
  //   } else {
  //     Setduedeposit(0); // optional: if paid is equal or more, due is 0
  //   }
  // }, [deposit, paiddeposit]);

  //console.log("paiddeposit", paiddeposit);
  const [formData, setFormData] = useState(() => ({
    mvrDownloaded: "yes",
    // mvrFile: uploadedDamageImages,
    driving_licence_image: null,
    feeAgreement: "",
    firstName: firstName || "",
    lastName: lastName || "",
    // dob: dob_date !== "" ? dob_date : maxDob || "",
    dob: "",
    licenseState: "",
    drivingState: "",
    licenseExpiry: "",
    phone: "",
    address: present_map_address || "",
    email: customer_email || "",
    ssn: "",
    city: "",
    license: "",
    rideshareApproval: "no",
    hireExperience: "",
    carPreference: [],
    rentalDuration: "",
    rentalStart: "",
    carUsage: [],
    carUsageOther: "",
    workApproval: [],
    workApprovalOther: "",
    emergencyContact1: {
      name: "",
      relation: "",
      phone: "",
    },
    emergencyContact2: {
      name: "",
      relation: "",
      phone: "",
    },
    submissionDate: "",
    signature_image: null,
    rideshare_aproval_image: null,
  }));

  const usStates = [
    { name: "Alabama", abbr: "AL" },
    { name: "Alaska", abbr: "AK" },
    { name: "Arizona", abbr: "AZ" },
    { name: "Arkansas", abbr: "AR" },
    { name: "California", abbr: "CA" },
    { name: "Colorado", abbr: "CO" },
    { name: "Connecticut", abbr: "CT" },
    { name: "Delaware", abbr: "DE" },
    { name: "Florida", abbr: "FL" },
    { name: "Georgia", abbr: "GA" },
    { name: "Hawaii", abbr: "HI" },
    { name: "Idaho", abbr: "ID" },
    { name: "Illinois", abbr: "IL" },
    { name: "Indiana", abbr: "IN" },
    { name: "Iowa", abbr: "IA" },
    { name: "Kansas", abbr: "KS" },
    { name: "Kentucky", abbr: "KY" },
    { name: "Louisiana", abbr: "LA" },
    { name: "Maine", abbr: "ME" },
    { name: "Maryland", abbr: "MD" },
    { name: "Massachusetts", abbr: "MA" },
    { name: "Michigan", abbr: "MI" },
    { name: "Minnesota", abbr: "MN" },
    { name: "Mississippi", abbr: "MS" },
    { name: "Missouri", abbr: "MO" },
    { name: "Montana", abbr: "MT" },
    { name: "Nebraska", abbr: "NE" },
    { name: "Nevada", abbr: "NV" },
    { name: "New Hampshire", abbr: "NH" },
    { name: "New Jersey", abbr: "NJ" },
    { name: "New Mexico", abbr: "NM" },
    { name: "New York", abbr: "NY" },
    { name: "North Carolina", abbr: "NC" },
    { name: "North Dakota", abbr: "ND" },
    { name: "Ohio", abbr: "OH" },
    { name: "Oklahoma", abbr: "OK" },
    { name: "Oregon", abbr: "OR" },
    { name: "Pennsylvania", abbr: "PA" },
    { name: "Rhode Island", abbr: "RI" },
    { name: "South Carolina", abbr: "SC" },
    { name: "South Dakota", abbr: "SD" },
    { name: "Tennessee", abbr: "TN" },
    { name: "Texas", abbr: "TX" },
    { name: "Utah", abbr: "UT" },
    { name: "Vermont", abbr: "VT" },
    { name: "Virginia", abbr: "VA" },
    { name: "Washington", abbr: "WA" },
    { name: "West Virginia", abbr: "WV" },
    { name: "Wisconsin", abbr: "WI" },
    { name: "Wyoming", abbr: "WY" },
    { name: "District of Columbia", abbr: "DC" },
  ];
  ///////////////----------------------------------Get data ------------
  const calculateDays = (pickupDate, dropDate) => {
    const pickup = new Date(pickupDate);
    const drop = new Date(dropDate);
    if (isNaN(pickup) || isNaN(drop)) {
      return "Invalid dates provided";
    }
    if (drop <= pickup) {
      return "Drop date must be after pickup date";
    }
    const differenceInTime = drop - pickup;
    if (differenceInTime === 0) {
      return 1; // Return 1 if the dates are the same
    }
    const differenceInDays = Math.ceil(
      differenceInTime / (1000 * 60 * 60 * 24)
    );
    return differenceInDays > 0 ? differenceInDays : "Invalid date range";
  };

  useEffect(() => {
    if (pickupdate && dropdate && selectedcarprice) {
      let days = calculateDays(pickupdate, dropdate);
      if (days > 0) {
        const final_price = days * selectedcarprice;
        setFinalPrice(final_price.toFixed(2)); // Update the final price in state
      } else {
        setFinalPrice(null); // Handle invalid date ranges
      }
    }
  }, [pickupdate, dropdate, selectedcarprice]);

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   if (name === "phone" || name === "zipcode") {
  //     // Remove non-digit characters and limit to 10 digits
  //     const formattedPhone = value.replace(/\D/g, "").slice(0, 10);
  //     setFormData({ ...formData, [name]: formattedPhone });
  //   } else if (type === "checkbox") {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: checked
  //         ? [...prevData[name], value]
  //         : prevData[name].filter((item) => item !== value),
  //     }));
  //   } else if (type === "file") {
  //     setFormData({ ...formData, [name]: e.target.files[0] });
  //   } else {
  //     setFormData({ ...formData, [name]: value });
  //   }
  // };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "phone") {
      // Remove non-digit characters and limit to 10 digits
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);

      // Format for display: (XXX) XXX-XXXX
      let formattedValue = digitsOnly;
      if (digitsOnly.length > 3 && digitsOnly.length <= 6) {
        formattedValue = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
      } else if (digitsOnly.length > 6) {
        formattedValue = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(
          3,
          6
        )}-${digitsOnly.slice(6)}`;
      }

      // Save only digits, and keep formatted version for UI
      setFormData((prev) => ({
        ...prev,
        [name]: digitsOnly,
        [`${name}Display`]: formattedValue,
      }));
    } else if (name === "zipcode") {
      const formattedZip = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, [name]: formattedZip });
    } else if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked
          ? [...prevData[name], value]
          : prevData[name].filter((item) => item !== value),
      }));
    } else if (type === "file") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    if (formData.phone && !formData.phoneDisplay) {
      const num = formData.phone;
      let formattedValue = num;
      if (num.length > 3 && num.length <= 6) {
        formattedValue = `(${num.slice(0, 3)}) ${num.slice(3)}`;
      } else if (num.length > 6) {
        formattedValue = `(${num.slice(0, 3)}) ${num.slice(3, 6)}-${num.slice(
          6
        )}`;
      }

      setFormData((prev) => ({
        ...prev,
        phoneDisplay: formattedValue,
      }));
    }
  }, [formData.phone]);

  useEffect(() => {
    // Check if 'data' is defined and has 'endDate' and 'fromDate'
    if (!data || !data.endDate || !data.fromDate) {
      console.error("Dates are missing or 'data' is not available.");
      return;
    }

    const endDate = new Date(data.endDate);
    const fromDate = new Date(data.fromDate);

    if (isNaN(endDate) || isNaN(fromDate)) {
      console.error("Invalid date format.");
      return;
    }

    const differenceInTime = endDate - fromDate;
    let daysDifference = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));

    if (daysDifference === 0) {
      daysDifference = 1;
    }

    if (daysDifference > 0) {
      setNumberOfDays(daysDifference);
      const carPrice = Number(data.car_price);
      const total = daysDifference * carPrice;
      setTotalCost(total);
    } else {
      console.error("End date is earlier than the from date.");
    }
  }, [data?.endDate, data?.fromDate]);

  // License expiry calculation
  const licenseExpiry =
    driving_expiration_date !== ""
      ? new Date(driving_expiration_date)
      : new Date(data?.endDate || "Invalid date");

  const handleEmergencyChange = (e, contactNumber) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [`emergencyContact${contactNumber}`]: {
        ...prevData[`emergencyContact${contactNumber}`],
        [name]: value,
      },
    }));
  };
  const step1Errors = () => {
    let errors = {};
    if (!formData.mvrDownloaded)
      errors.mvrDownloaded = "This field is required.";
    if (formData.mvrDownloaded !== "yes")
      errors.mvrFile = "Please upload the MVR file.";
    if (!formData.firstName) errors.firstName = "First name is required.";
    if (!formData.lastName) errors.lastName = "Last name is required.";
    if (!formData.dob) errors.dob = "Date of Birth is required.";
    if (!formData.licenseExpiry)
      errors.licenseExpiry = "License Expiry date is required.";
    if (!formData.phone) {
      errors.phone = "Phone number is required.";
    } else {
      // Remove any non-digit characters
      const phoneNumber = formData.phone.replace(/\D/g, "");

      // Check if the phone number is exactly 10 digits
      if (phoneNumber.length !== 10) {
        errors.phone = "Phone number must be 10 digits long.";
      } else {
        // Additional validation for common US phone number formats
        const firstThreeDigits = phoneNumber.substring(0, 3);
        const invalidAreaCodes = ["000", "111", "911"];

        if (invalidAreaCodes.includes(firstThreeDigits)) {
          errors.phone = "Invalid phone number format.";
        }
      }
    }
    if (!formData.email) errors.email = "Email is required.";
    if (!formData.address) errors.address = "Street Address is required.";
    if (!formData.city) errors.city = "City is required.";
    if (!formData.zipcode) errors.zipcode = "Zipcode is required.";
    if (!formData.driving_licence_image)
      errors.driving_licence_image = "Please upload a PDF of your license.";
    if (!formData.drivingState) errors.drivingState = "Please select a state.";
    if (!formData.license) errors.license = "Driver's license is required.";
    console.log(errors);
    return errors;
  };

  const uploadImageserver = async (file, index) => {
    const fd = new FormData();
    fd.append("image", file);
    fd.append("image_tag", "mvr_image");

    try {
      const response = await server_post_data(upload_image_to_folder, fd);
      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const uploadedImageName = response.data.message.image_uploaded;

        // add to uploadedDamageImages array
        setUploadedDamageImages((prev) => {
          const newArr = [...prev, uploadedImageName];
          // also set formData.mvrFile to a truthy value to mark that MVR is uploaded
          setFormData((prevForm) => ({
            ...prevForm,
            mvrFile: newArr.length > 0 ? newArr : "",
          }));
          return newArr;
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };
  const handleRemoveImage = (index) => {
    setUploadedDamageImages((prev) => {
      const updatedImages = prev.filter((_, i) => i !== index);

      // update formData.mvrFile accordingly: clear if no images left, otherwise keep array
      setFormData((prevForm) => ({
        ...prevForm,
        mvrFile: updatedImages.length > 0 ? updatedImages : "",
      }));

      return updatedImages;
    });
  };

  const handleFileChangeMVR = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + uploadedDamageImages.length > 3) {
      alert("You can only upload a maximum of 3 images.");
      return;
    }

    const remainingSlots = 3 - uploadedDamageImages.length;
    const filesToUpload = files.slice(0, remainingSlots);

    // Start uploading each file. uploadImageserver will update uploadedDamageImages and formData.mvrFile
    filesToUpload.forEach((file, index) => {
      uploadImageserver(file, index);
    });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.ssn) newErrors.ssn = "SSN is required.";

    if (!formData.rideshareApproval) {
      newErrors.rideshareApproval = "This field is required.";
    }
    //yes no logic
    if (formData.rideshareApproval === "yes" && !formData.hireExperience) {
      newErrors.hireExperience = "Experience is required.";
    }
    // Check if rideshareApproval is not "yes" and carUsage is empty
    if (formData.rideshareApproval === "no" && formData.carUsage.length === 0) {
      newErrors.carUsage = "Please select at least one usage.";
      if (formData.carUsage.includes("Other") && !formData.carUsageOther)
        newErrors.carUsageOther = "Specify other car usage.";
    }
    if (
      formData.rideshareApproval === "yes" &&
      formData.workApproval.length === 0
    )
      newErrors.workApproval = "Please select at least one approval.";
    if (
      formData.rideshareApproval === "yes" &&
      formData.workApproval.includes("Other") &&
      !formData.workApprovalOther
    )
      newErrors.workApprovalOther = "Specify other platform.";
    if (!formData.rentalStart)
      newErrors.rentalStart = "Please select a rental start option.";
    // Validate Emergency Contact 1
    if (!formData.emergencyContact1.name)
      newErrors.emergencyContact1_name = "Name is required.";
    if (!formData.emergencyContact1.relation)
      newErrors.emergencyContact1_relation = "Relation is required.";
    if (!formData.emergencyContact1.phone)
      newErrors.emergencyContact1_phone = "Phone Number is required.";

    // Validate Emergency Contact 2
    if (!formData.emergencyContact2.name)
      newErrors.emergencyContact2_name = "Name is required.";
    if (!formData.emergencyContact2.relation)
      newErrors.emergencyContact2_relation = "Relation is required.";
    if (!formData.emergencyContact2.phone)
      newErrors.emergencyContact2_phone = "Phone Number is required.";

    // Validate Emergency Contacts and Compare
    if (formData.emergencyContact2.name == formData.emergencyContact1.name)
      newErrors.emergencyContactsame =
        "Names must not match. Please enter two different names.";
    if (formData.emergencyContact2.phone == formData.emergencyContact1.phone)
      newErrors.emergencyContactsame =
        "Phone Numbers must not match. Please enter two different Numbers.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBack = () => setStep(step - 1);
  const handleNext = () => {
    const errors = step1Errors();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      toast.error(
        "Form submission failed. Please review the highlighted fields and correct the errors."
      );
      return;
    }
    setStep(step + 1);
  };
  const handleNext2 = () => {
    if (!validateForm()) {
      toast.error(
        "Form submission failed. Please review the highlighted fields and correct the errors."
      );
      return;
    }
    setStep(step + 1);
  };
  // const nextStep = () => {
  //     if (validateForm() && step1Errors()) {
  //         setStep(3); // Skip to Step 3 if all data is valid
  //     } else if (validateForm()) {
  //         setStep(2); // Move to Step 2 if Step 1 is valid
  //     } else {
  //         setStep(1); // Stay on Step 1 if errors exist
  //     }
  // };

  // const prevStep = () => {
  //     if (step > 1) {
  //         setStep(step - 1); // Allow going back
  //     }
  // };

  // useEffect(() => {
  //     nextStep();
  // }, []);

  const signaturePad = useRef(null);

  const handleClearSignature = () => {
    signaturePad.current.clear();
  };

  const handleSaveSignature = () => {
    if (signaturePad.current.isEmpty()) {
      alert("Please provide a signature before proceeding.");
      return;
    }
    const signatureData = signaturePad.current.toDataURL("image/png");
    const base64String = signatureData.split(",")[1];
    const byteArray = new Uint8Array(
      atob(base64String)
        .split("")
        .map((c) => c.charCodeAt(0))
    );
    const blob = new Blob([byteArray], { type: "image/png" });
    const file = new File([blob], "signature.png", { type: "image/png" });
    setFormData((prevData) => ({
      ...prevData,
      signature_image: file,
    }));

    alert("Signature saved as PNG and downloaded!");
  };

  function formatDateTimenew(date) {
    const d = new Date(date);

    // Get date components
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const [error, setError] = useState("");
  const handleSubmitImg = async () => {
    // if (!validateForm()) {
    //     return;
    // }
    if (click_type == 0) {
      click_type = 1;

      let fd_from = new FormData();
      // fd_from.append("main_id", id);
      fd_from.append("signature_image", formData.signature_image);
      fd_from.append(
        "emergency_relation2",
        formData.emergencyContact2.relation
      );
      fd_from.append("emergency_name2", formData.emergencyContact2.name);
      fd_from.append("emergency_number2", formData.emergencyContact2.phone);
      fd_from.append(
        "emergency_relation1",
        formData.emergencyContact1.relation
      );
      fd_from.append("emergency_name1", formData.emergencyContact1.name);
      fd_from.append("emergency_number1", formData.emergencyContact1.phone);
      fd_from.append("work_for", formData.workApproval);
      fd_from.append("long_need_car", formData.rentalStart);
      fd_from.append("city", formData.city);

      fd_from.append("ready_for_rideshare", formData.rideshareApproval);
      if (formData.rideshareApproval === "no") {
        fd_from.append("experience_year", "0");
      } else {
        fd_from.append("experience_year", formData.hireExperience);
      }
      fd_from.append("driving_licence_number", formData.license);
      fd_from.append("ssn_number", formData.ssn);
      fd_from.append("present_map_address", formData.address);
      fd_from.append(
        "driving_expiration_date",
        formatDateTimenew(formData.licenseExpiry)
      );
      fd_from.append("mvp_pdf", formData.mvrFile);
      fd_from.append("mvr_status", formData.mvrDownloaded);
      fd_from.append("driving_licence_image", formData.driving_licence_image);
      fd_from.append(
        "rideshare_aproval_image",
        formData.rideshare_aproval_image
      );
      fd_from.append("using_car", formData.carUsage);
      fd_from.append("end_date", "0");
      fd_from.append("from_date", getApplicationdata.from_date);
      fd_from.append("car_id", getApplicationdata.car_id);
      // fd_from.append("car_price", "0");
      // fd_from.append("total_price", 0);
      fd_from.append("phone_number", formData.phone);
      fd_from.append("email", formData.email);
      fd_from.append("dob", formatDateTimenew(formData.dob));
      fd_from.append("last_name", formData.lastName);
      fd_from.append("first_name", formData.firstName);
      fd_from.append("state_dropdown", formData.licenseState);
      fd_from.append("driving_state", formData.drivingState);
      // fd_from.append("signature_image", signUploadImg);
      fd_from.append("main_id", getApplicationdata.primary_id);
      fd_from.append("userid", getApplicationdata.car_id);
      // TNC Ofc ew fields
      fd_from.append(
        "agree_for_tolls_ticket",
        formState.tollsTicketAgree === true ? 1 : 0
      );
      fd_from.append(
        "agree_for_discloser",
        formState.disclosureAgree === true ? 1 : 0
      );
      fd_from.append(
        "agree_for_do_and_dont",
        formState.dosAndDontsAgree === true ? 1 : 0
      );
      fd_from.append(
        "terms_annd_condition",
        formState.insuranceAgree === true ? 1 : 0
      );

      // if (formState.parkingOption.length > 0) {
      //     fd_from.append("parkingOption", formState.parkingOption);
      // } else {
      //     fd_from.append("parkingOption", "");
      // }

      fd_from.append("per_date_charge", formState.paymentAmount);
      // fd_from.append("roadsideAssistant", formState.roadsideAssistant);
      fd_from.append("paymentOption", formState.paymentOption);
      // fd_from.append("otherParkingOption", formState.otherParkingOption);

      if (formState.otherParkingOption === "Other") {
        // Ensure roadsideAssistant is an array

        fd_from.append(
          "roadsideAssistant",
          formState.parkingOption.push(formState.otherParkingOption)
        );
        // const updatedRoadsideAssistant = Array.isArray(formState.parkingOption)
        //   ? [...formState.roadsideAssistant, formState.otherParkingOption]
        //   : [formState.otherParkingOption];

        // fd_from.append("roadsideAssistant", updatedRoadsideAssistant);
      } else {
        fd_from.append("roadsideAssistant", formState.parkingOption);
      }
      fd_from.append("total_surcharges", surcharges);
      fd_from.append("total_deposit", deposit);
      fd_from.append("paid_deposit", paiddeposit);
      fd_from.append("due_deposit", duedeposit);
      fd_from.append(
        "payment_day_week",
        formState.day_weekly == "Weekly" ? 2 : 1
      );
      fd_from.append("DamgeImage", JSON.stringify([]));

      await server_post_data(create_walkIn_booking_edit, fd_from)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            console.log();
            handleSuccessSession(Response.data.message, "/Bookings");
            // window.location.reload();
          }
          click_type = 0;
        })
        .catch((error) => {
          click_type = 0;
          console.log(error);
        });
    }
  };
  useEffect(() => {
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("booking_id", id);

    await server_post_data(get_booking_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setgetApplicationdata(Response.data.message.data);
          let finaldata = Response.data.message.data;
          console.log("finaldata", finaldata);
          SetSignImg(APL_LINK + Response.data.message.image_link_signature);
          SetDLImg(APL_LINK + Response.data.message.image_link);
          SetMvrUrl(APL_LINK + Response.data.message.image_link);
          //console.log("finaldata.mvp_status", finaldata.mvp_status);
          if (finaldata.office_use_status === "1") {
            setStep(4);
          }
          let damage_image = Response.data.message.damage_image;
          // Assuming `damage_image` is an array of objects with `.image`
          const extractedImages = damage_image.map((item) => item.image);
          // Set images in state
          setUploadedDamageImages(extractedImages);
          let workApprovalData = [];
          let workApprovalOtherData = "";
          let usingCarForData = [];
          let usingCarForOtherData = "";

          if (finaldata.work_for) {
            const [mainPart, otherPart] = finaldata.work_for.split("@~");
            workApprovalData = mainPart.split(",");
            workApprovalOtherData = otherPart || "";

            if (workApprovalOtherData) {
              workApprovalData.push("Other"); // Display "Other" in checkbox
            }
          }

          if (finaldata.using_car_for) {
            const [mainPart, otherPart] = finaldata.using_car_for.split("@~");
            usingCarForData = mainPart.split(",");
            usingCarForOtherData = otherPart;

            console.log(usingCarForOtherData);
            if (usingCarForOtherData) {
              usingCarForData.push("Other"); // Display "Other" in checkbox
            }
          }

          setFormData({
            mvrDownloaded: finaldata.mvp_status,
            mvrFile: finaldata.mvp_pdf,
            driving_licence_image: finaldata.driving_licence_image,
            feeAgreement: "",
            firstName: finaldata.first_name || "",
            lastName: finaldata.last_name || "",
            dob: finaldata.dob_date || "",

            drivingState: finaldata.state || "",
            license: finaldata?.driving_licence || "",
            licenseState: finaldata.state_dropdown || "",
            licenseExpiry: finaldata.driving_expiration_date || "",
            phone: finaldata.mobile_no || "",
            address: finaldata.present_map_address || "",
            email: finaldata.email || "",
            zipcode: finaldata.pin_code || "",
            city: finaldata.city || "",
            rideshareApproval: finaldata.ready_for_rideshare,
            hireExperience: finaldata.passenger_for_hire_expe || "",
            carPreference: [],
            rentalDuration: "",
            rentalStart: finaldata.long_need_car || "",
            ssn: finaldata.last_digit_ssn || "",
            carUsage: finaldata.using_car_for || "",
            carUsageOther: usingCarForOtherData || "",
            workApproval: finaldata.work_for || "",
            workApprovalOther: workApprovalOtherData || "",
            submissionDate: "",
            signature_image: finaldata.signature_image,
            emergencyContact1: {
              name: finaldata.emergency_contacts_name || "",
              relation: finaldata.emergency_contacts_relation || "",
              phone: finaldata.emergency_contacts || "",
            },
            emergencyContact2: {
              name: finaldata.emergency_contacts_name1 || "",
              relation: finaldata.emergency_contacts_relation1 || "",
              phone: finaldata.emergency_contacts1 || "",
            },
            rideshare_aproval_image: finaldata.rideshare_aproval_image,
          });
          Setdeposit(finaldata.total_deposit);
          Setdepositfirst(finaldata.total_deposit);
          // Setpaiddeposit(0);
          SetpaiddepositFirst(finaldata.paid_deposit);
          if (finaldata.paid_deposit == 250) {
            Setpaiddeposit(250);
          } else {
            Setpaiddeposit(0);
          }
          Setduedeposit(finaldata.due_deposit);
          console.log(
            "finaldata.parking_assistance",
            finaldata.parking_assistance
          );
          setFormState({
            parkingOption: finaldata.parking_assistance
              ? finaldata.parking_assistance.split(",")
              : [],
            paymentAmount: carData.Price,
            roadsideAssistant: finaldata.aaa_road_side_assistance,
            paymentOption: finaldata.payment_method,
            otherParkingOption: "",
            tollsTicketAgree: true,
            disclosureAgree: true,
            dosAndDontsAgree: true,
            insuranceAgree: true,
            // day_weekly: finaldata.payment_day_week == 1 ? "Daily" : "Weekly",
            day_weekly: "",
          });
          Setsurcharges(finaldata.per_day_surcharges);
          // Setdeposit(finaldata.total_deposit);
        }
        // parking_assistance
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const [isEditing, setIsEditing] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [isEditing3, setIsEditing3] = useState(false);
  const [isEditing4, setIsEditing4] = useState(false);
  const handleEditClick = () => {
    setIsEditing(!isEditing);
  };
  const handleEditClick2 = () => {
    setIsEditing2(!isEditing2);
  };
  const handleEditClick3 = () => {
    setIsEditing3(!isEditing3);
  };

  const handleEditClick4 = () => {
    setIsEditing4(!isEditing3);
  };

  const [signUploadImg, setSignUploadImg] = useState(null);

  const handleSignatureUpload = (event) => {
    const uploadedFile = event.target.files[0];
    if (uploadedFile) {
      setSignUploadImg(uploadedFile);
    }
  };

  const [formState, setFormState] = useState({
    tollsTicketAgree: true,
    disclosureAgree: true,
    dosAndDontsAgree: true,
    parkingOption: [],
    paymentAmount: "",
    roadsideAssistant: "",
    insuranceAgree: true,
    paymentOption: "",
    otherParkingOption: "",
    // surcharges: "",
    day_weekly: " ",
  });
  const [formErrors, setFormErrors] = useState({
    paymentOption: "",
    paymentAmount: "",
    parkingOption: "",
    day_weekly: "",
    deposit_value: "",
    due_deposit: "",
  });

  const handleChange2 = (e) => {
    const { value, checked, name, type } = e.target;
    if (type === "radio") {
      setFormState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
    if (type === "checkbox") {
      let updatedValues = [...formState[name]];

      if (checked) {
        updatedValues.push(value);
      } else {
        updatedValues = updatedValues.filter((option) => option !== value);
      }

      setFormState((prevState) => ({
        ...prevState,
        [name]: updatedValues,
      }));
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };
  const handleCatchError3 = () => {
    let errors = {};
    let isValid = true;
    if (formState.parkingOption.length === 0) {
      errors.parkingOption = "Please select at least one parking option.";
      isValid = false;
    }
    // if (formState.roadsideAssistant.length === 0) {
    //   errors.roadsideAssistant = "Please select the Road Side Assistant.";
    //   isValid = false;
    // }
    setFormErrors(errors);
    return { isValid, errors };
  };
  const handleCatchError = () => {
    let errors = {};
    let isValid = true;

    if (paiddeposit !== "0") {
      console.log(paiddeposit);
      if (!formState.paymentOption) {
        errors.paymentOption = "Please select a payment option.";
        isValid = false;
      }
    }

    // if (!formState.paymentAmount) {
    //   errors.paymentAmount = "Please select a payment amount.";
    //   isValid = false;
    // }
    // if (formState.parkingOption.length === 0) {
    //   errors.parkingOption = "Please select at least one parking option.";
    //   isValid = false;
    // }
    // if (formState.day_weekly.length === 0) {
    //   errors.parkingOption = "Please select at least one .";
    //   isValid = false;
    // }
    // Validate payment cycle (day_weekly)
    if (!formState.day_weekly) {
      errors.day_weekly = "Please select a payment cycle.";
      isValid = false;
    }

    // Validate surcharges
    // if (!surcharges) {
    //   errors.surcharges = "Surcharges amount is required.";
    //   isValid = false;
    // }

    // Validate deposit
    // if (!deposit) {
    //   errors.deposit = "Deposit amount is required.";
    //   isValid = false;
    // }

    // Validate paid deposit
    if (!paiddeposit) {
      errors.paid_deposit = "Paid deposit amount is required.";
      isValid = false;
    }

    // Validate due deposit
    if (duedeposit < 0) {
      Setduedeposit(0);
      errors.due_deposit = "Due deposit amount is required.";
      isValid = false;
    }

    if (deposit < paiddepositFirst) {
      errors.deposit_value =
        "Deposit amount cannot be less than received amount.";
      isValid = false;
    }

    setFormErrors(errors);
    return { isValid, errors };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { isValid, errors } = handleCatchError();
    console.log(handleCatchError());
    if (!isValid) {
      toast.error(
        "Form submission failed. Please review the highlighted fields and correct the errors."
      );
      setFormErrors(errors);
    } else {
      handleSubmitImg();
    }
  };

  //console.log("Current value:", formState.roadsideAssistant);
  const isReadOnly = getApplicationdata.office_use_status == 0;
  //console.log("wndjeded", isReadOnly);

  const handlepaiddeposit = (e) => {
    const input = e;
    console.log(input);
    // Allow empty input
    if (input == "") {
      Setpaiddeposit("");
      Setduedeposit(deposit);
      lastValidPaid.current = ""; // Reset ref
      return;
    }

    // Allow only numbers + optional decimal
    if (!/^\d*\.?\d*$/.test(input)) return;

    const value = parseFloat(input);

    if (isNaN(value)) {
      alert("Please enter a valid number");
      Setpaiddeposit(lastValidPaid.current); // restore previous
      return;
    }

    if (value < 0) {
      alert("Paid amount cannot be negative");
      Setpaiddeposit(lastValidPaid.current); // restore previous
      return;
    }

    // ✅ Valid — update everything
    Setpaiddeposit(input);
    Setduedeposit(deposit - paiddepositFirst - value);
    lastValidPaid.current = input; // 💾 save as last valid
  };

  const handlepaiddepositforfunct = (e) => {
    const input = e;
    console.log(input);
    // Allow empty input
    if (input == "") {
      Setpaiddeposit("");
      Setduedeposit(deposit);
      lastValidPaid.current = ""; // Reset ref
      return;
    }

    // Allow only numbers + optional decimal
    if (!/^\d*\.?\d*$/.test(input)) return;

    const value = parseFloat(input);

    if (isNaN(value)) {
      alert("Please enter a valid number");
      Setpaiddeposit(lastValidPaid.current); // restore previous
      return;
    }

    if (value < 0) {
      alert("Paid amount cannot be negative");
      Setpaiddeposit(lastValidPaid.current); // restore previous
      return;
    }

    // ✅ Valid — update everything
    Setpaiddeposit(input);
    Setduedeposit(deposit - value);
    lastValidPaid.current = input; // 💾 save as last valid
  };

  function mmtry(amt, flag) {
    let errors = {};
    let isValid = true;
    let stopsubmit = 0;
    let depositamt = deposit;
    let paidamt = paiddeposit; // paiddeposit
    let dueamt = duedeposit;
    //console.log("actual  deposit:", deposit);
    if (flag == 1) {
      //total deposit
      depositamt = amt;
    }
    if (flag == 2) {
      //paid deposit
      //console.log(amt);
      paidamt = amt;
    }
    if (flag == 3) {
      //Due Deposit
      dueamt = amt;
    }

    if (depositamt < paiddepositFirst) {
      errors.deposit_value =
        "Deposit amount cannot be less than received amount.";
      isValid = false;
      if (paiddepositFirst != 0) {
        //depositamt = paiddepositFirst;
      } else {
        //depositamt = 250;
      }
    }
    let totalpaiddeposit = Number(paiddepositFirst) + Number(paidamt);
    //console.log("totalpaiddeposit: ", totalpaiddeposit);
    if (depositamt < totalpaiddeposit) {
      console.log(paidamt > totalpaiddeposit);
      errors.paid_deposit =
        "Paid Deposit amount cannot be Greater than Deposit amount.";
      isValid = false;
      paidamt = 0;
    }

    let totalduedeposit = depositamt - totalpaiddeposit;
    Setduedeposit(totalduedeposit);

    setFormErrors(errors);
    Setdeposit(depositamt);
    Setpaiddeposit(paidamt);
    //Setduedeposit(dueamt);
    return { isValid, errors };
  }

  return (
    <div>
      {showLoaderAdmin && <Loader />}
      <Header />
      <div className="container-lg">
        <div className="pageCntn_head">
          <div className="pageNameDiv">
            <Breadcrumb
              items={[
                { label: "Bookings", path: "/Bookings" },
                { label: "Edit Application", path: "/Edit_application" },
              ]}
            />
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>
      </div>

      <div className="page_body container-lg">
        <div>
          <div className="page-header pt-30 background-body">
            <div className="container newFormContainer overFLow_scll_clss">
              <div className="container">
                <div className="mt-4 mb-4 form-container">
                  <form>
                    {step === 1 && (
                      <div className="form-step">
                        <h6 className="mb-4">Step 1: Basic Information</h6>
                        <div className="row m-0">
                          {/* MVR Downloaded Question */}
                          <label className="col-md-6 mb-3">
                            <span>
                              Have you downloaded the MVR (For Court Purpose)
                              and ready to upload?{" "}
                            </span>

                            {/* Radio buttons for Yes/No */}
                            <div
                              className="check_box_mvr"
                              style={{ marginTop: "10px" }}
                            >
                              <input
                                type="radio"
                                id="mvrYes"
                                name="mvrDownloaded"
                                value="yes"
                                checked={formData.mvrDownloaded === "yes"}
                                onChange={(e) => {
                                  handleChange(e);
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    mvrDownloaded: "",
                                  }));
                                }}
                              />
                              <label
                                htmlFor="mvrYes"
                                style={{ marginRight: "20px" }}
                              >
                                Yes
                              </label>

                              <input
                                type="radio"
                                id="mvrNo"
                                name="mvrDownloaded"
                                value="no"
                                checked={formData.mvrDownloaded === "no"}
                                onChange={(e) => {
                                  handleChange(e);
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    mvrDownloaded: "",
                                  }));
                                }}
                              />
                              <label htmlFor="mvrNo">No</label>
                            </div>

                            {errors.mvrDownloaded && (
                              <span className="error-message">
                                {errors.mvrDownloaded}
                              </span>
                            )}
                          </label>

                          {/* MVR File Upload */}
                          <label className="col-md-6 mb-3">
                            {formData.mvrDownloaded === "yes" && (
                              <>
                                {!formData.mvrFile || isEditing3 ? (
                                  <span onClick={handleEditClick3}>
                                    Upload MVR For Court Purpose
                                    <span style={{ color: "red" }}>*</span>
                                    {isEditing3 ? (
                                      <X size={20} />
                                    ) : (
                                      <Edit size={20} />
                                    )}
                                  </span>
                                ) : (
                                  <span onClick={handleEditClick3}>
                                    {isEditing3 ? (
                                      <X size={20} />
                                    ) : (
                                      <Edit size={20} />
                                    )}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                )}

                                {/* {!formData.mvrFile || isEditing3 ? ( */}
                                <>
                                  <div className="margin_reviewmodel">
                                    <div className="col-sm">
                                      <div className="img_upd_contr">
                                        <div
                                          className="media-placeholder upload_img_contr"
                                          onClick={() => {
                                            if (uploadedDamageImages.length < 4)
                                              document
                                                .getElementById(
                                                  "damageFileInput"
                                                )
                                                .click();
                                          }}
                                          style={{
                                            opacity:
                                              uploadedDamageImages.length >= 4
                                                ? 0.5
                                                : 1,
                                            pointerEvents:
                                              uploadedDamageImages.length >= 4
                                                ? "none"
                                                : "auto",
                                          }}
                                        >
                                          <div className="empty-upload-text">
                                            <i className="bi bi-cloud-upload"></i>
                                            <span>Browse</span>
                                          </div>
                                          <input
                                            type="file"
                                            id="damageFileInput"
                                            accept="image/*"
                                            multiple
                                            style={{ display: "none" }}
                                            onChange={handleFileChangeMVR}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    {[...Array(3)].map((_, index) => (
                                      <div
                                        key={index}
                                        className="col-sm"
                                        style={{ position: "relative" }}
                                      >
                                        {uploadedDamageImages[index] &&
                                          uploadedDamageImages[index] !==
                                            "0" && (
                                            <div
                                              className="hoverRemoveImg"
                                              onClick={() =>
                                                handleRemoveImage(index)
                                              }
                                            >
                                              <XIcon className="rmv_icn" />
                                            </div>
                                          )}
                                        <div className="media-placeholder car-image">
                                          {uploadedDamageImages[index] &&
                                          uploadedDamageImages[index] !==
                                            "0" ? (
                                            <img
                                              src={
                                                MvrUrl +
                                                  uploadedDamageImages[index] ||
                                                "/placeholder.svg"
                                              }
                                              alt={`Damage ${index + 1}`}
                                              style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                              }}
                                            />
                                          ) : (
                                            <div
                                              className="empty-upload-text"
                                              style={{ opacity: 0.5 }}
                                            >
                                              <UploadIcon
                                                size={20}
                                                color="#aaa"
                                              />
                                              <span
                                                style={{
                                                  marginLeft: "10px",
                                                }}
                                              >
                                                Empty
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </>
                              </>
                            )}
                          </label>

                          <label key="firstName" className="col-md-4 mb-3">
                            <span>
                              First Name <span style={{ color: "red" }}>*</span>
                            </span>
                            <input
                              type="text"
                              name="firstName"
                              value={formData.firstName}
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  firstName: "",
                                }));
                              }}
                              onKeyPress={(e) => {
                                if (!/^[a-zA-Z]*$/.test(e.key)) {
                                  e.preventDefault(); // Allow only alphabets
                                }
                              }}
                              maxLength={12}
                              required
                              disabled
                            />
                            {errors.firstName && (
                              <span className="error-message">
                                {errors.firstName}
                              </span>
                            )}
                          </label>

                          <label key="lastName" className="col-md-4 mb-3">
                            <span>
                              Last Name <span style={{ color: "red" }}>*</span>
                            </span>
                            <input
                              type="text"
                              name="lastName"
                              value={formData.lastName}
                              maxLength={12}
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  lastName: "",
                                }));
                              }}
                              onKeyPress={(e) => {
                                if (!/^[a-zA-Z]*$/.test(e.key)) {
                                  e.preventDefault(); // Allow only alphabets
                                }
                              }}
                              required
                              disabled
                            />
                            {errors.lastName && (
                              <span className="error-message">
                                {errors.lastName}
                              </span>
                            )}
                          </label>

                          <label key="phone" className="col-md-4 mb-3">
                            <span>
                              Phone Number{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                            {/* <input
                              type="tel"
                              name="phone"
                              maxLength={10}
                              value={formData.phone}
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  phone: "",
                                }));
                              }}
                              onKeyPress={(e) => {
                                if (!/^[0-9]*$/.test(e.key)) {
                                  e.preventDefault(); 
                                }
                              }}
                              required
                            /> */}
                            <input
                              type="tel"
                              name="phone"
                              maxLength={14} // allows formatted length
                              value={formData.phoneDisplay || ""} // show formatted version
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  phone: "",
                                }));
                              }}
                              onKeyPress={(e) => {
                                if (!/^[0-9]*$/.test(e.key)) {
                                  e.preventDefault(); // Allow only numbers
                                }
                              }}
                              required
                            />

                            {errors.phone && (
                              <span className="error-message">
                                {errors.phone}
                              </span>
                            )}
                          </label>

                          <label key="email" className="col-md-4 mb-3">
                            <span>
                              Email <span style={{ color: "red" }}>*</span>
                            </span>
                            <input
                              type="email"
                              name="email"
                              maxLength={50}
                              value={formData.email}
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  email: "",
                                }));
                              }}
                              required
                              disabled
                              onKeyPress={(e) => {
                                const allowedChars = /^[a-zA-Z0-9@.]*$/;
                                if (!allowedChars.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onBlur={(e) => {
                                const emailPattern =
                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                if (!emailPattern.test(e.target.value)) {
                                  setErrors({
                                    ...errors,
                                    email: "Please enter a valid email address",
                                  });
                                }
                              }}
                            />
                            {errors.email && (
                              <span className="error-message">
                                {errors.email}
                              </span>
                            )}
                          </label>

                          <div className="col-md-4 mb-3 ">
                            <div
                              className="d-flex"
                              style={{ flexDirection: "column" }}
                            >
                              <span>
                                Date of Birth
                                <span style={{ color: "red" }}>*</span>
                              </span>
                              <DatePicker
                                selected={formData.dob}
                                onChange={(date) => {
                                  setFormData((prevData) => ({
                                    ...prevData,
                                    dob: date,
                                  }));
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    dob: "",
                                  }));
                                }}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="search-input datepicker"
                                maxDate={maxDob}
                              />
                              {errors.dob && (
                                <span className="error-message">
                                  {errors.dob}
                                </span>
                              )}
                            </div>
                          </div>

                          {/* License Expiry */}
                          {/* <label className="col-md-4 mb-3 widrthClss">
                                                                    <span>
                                                                        Expiration of Driving License{" "}
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </span>
                                                                    <DatePicker
                                                                        selected={formData.licenseExpiry}
                                                                        onChange={(date) => {
                                                                            setFormData((prevData) => ({
                                                                                ...prevData,
                                                                                licenseExpiry: date,
                                                                            }));
                                                                            setErrors((prevErrors) => ({
                                                                                ...prevErrors,
                                                                                licenseExpiry: "",
                                                                            }));
                                                                        }}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        className="search-input datepicker "
                                                                        minDate={new Date()}
                                                                    />
                                                                    {errors.licenseExpiry && (
                                                                        <span className="error-message">
                                                                            {errors.licenseExpiry}
                                                                        </span>
                                                                    )}

                                                                </label> */}

                          <label className="col-md-12 mb-3">
                            <span>
                              Present Address{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>

                            {/* Street Address */}
                            <input
                              type="text"
                              name="address"
                              placeholder="Street Address"
                              value={formData.address}
                              maxLength={100}
                              onChange={(e) => {
                                handleChange(e);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  address: "",
                                }));
                              }}
                              required
                              style={{
                                display: "block",
                                width: "100%",
                                marginBottom: "10px",
                              }}
                            />
                            {errors.address && (
                              <span className="error-message">
                                {errors.address}
                              </span>
                            )}

                            {/* City */}
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "10px",
                              }}
                            >
                              <div className="col">
                                <input
                                  type="text"
                                  name="city"
                                  placeholder="City"
                                  value={formData.city}
                                  maxLength={50}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      city: "",
                                    }));
                                  }}
                                  required
                                  style={{
                                    display: "block",
                                    width: "100%",
                                    marginBottom: "10px",
                                  }}
                                />
                                {errors.city && (
                                  <span className="error-message">
                                    {errors.city}
                                  </span>
                                )}
                              </div>

                              {/* State */}
                              <div className="col">
                                <select
                                  name="drivingState"
                                  value={formData.drivingState || ""}
                                  onChange={(e) => {
                                    handleChange(e);
                                    if (errors.drivingState) {
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        drivingState: "",
                                      }));
                                    }
                                  }}
                                  required
                                  style={{
                                    backgroundColor: "#fff",
                                    height: "42px",
                                  }}
                                >
                                  <option value="">Select a state</option>
                                  {usStates.map((state) => (
                                    <option key={state.name} value={state.name}>
                                      {state.name}
                                    </option>
                                  ))}
                                </select>
                                {errors.drivingState && (
                                  <span style={{ color: "red" }}>
                                    {errors.drivingState}
                                  </span>
                                )}
                              </div>

                              {/* Zip Code */}
                              <div className="col">
                                <input
                                  type="text"
                                  name="zipcode"
                                  placeholder="Zip Code"
                                  value={formData.zipcode}
                                  maxLength={10}
                                  onChange={(e) => {
                                    handleChange(e);
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      zipcode: "",
                                    }));
                                  }}
                                  required
                                  style={{
                                    display: "block",
                                    width: "100%",
                                  }}
                                />
                                {errors.zipcode && (
                                  <span className="error-message">
                                    {errors.zipcode}
                                  </span>
                                )}
                              </div>
                            </div>
                          </label>

                          <label
                            className="col-md-4 mb-3"
                            style={{ marginTop: "5px" }}
                          >
                            <h6
                              style={{
                                fontSize: "14px",
                                marginBottom: "0px",
                              }}
                            >
                              Upload Drivers License {"  "}
                              <span
                                onClick={handleEditClick2}
                                className="Edit_bttCanvas"
                              >
                                {isEditing2 ? (
                                  <X size={20} />
                                ) : (
                                  <Edit size={20} />
                                )}
                              </span>
                              {/* <span style={{ color: "red" }}>*</span> */}
                            </h6>

                            {!formData.driving_licence_image || isEditing2 ? (
                              <input
                                type="file"
                                name="driving_licence_image"
                                accept="*/*"
                                onChange={(e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    handleChange(e); // Assuming this handles the state change
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      driving_licence_image: "",
                                    }));
                                  }
                                }}
                                required
                              />
                            ) : (
                              // <img className="uplaodDlDIV" src={DLImg + formData.driving_licence_image} alt="Driver's License" />
                              <a
                                className="uplaodDlDIV"
                                href={DLImg + formData.mvrFile}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {console.log(MvrUrl + formData.mvrFile)}
                                View Driving Licence
                              </a>
                            )}
                            {errors.driving_licence_image && (
                              <span style={{ color: "red" }}>
                                {errors.driving_licence_image}
                              </span>
                            )}
                          </label>
                          <label className="col-md-4 mb-3">
                            Driver's License number{" "}
                            <span style={{ color: "red" }}>*</span>
                            <input
                              type="text"
                              name="license"
                              value={formData.license}
                              maxLength={14}
                              onInput={validateDrivingLicense}
                              onChange={(e) => {
                                handleAlphabetsNumberWithoutSpaceChange(e);
                                handleChange(e);
                                if (errors.license) {
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    license: "",
                                  }));
                                }
                              }}
                              required
                            />
                            {errors.license && (
                              <span style={{ color: "red" }}>
                                {errors.license}
                              </span>
                            )}
                          </label>
                          {/* License Expiry */}
                          <div className="col-md-4 mb-3 widrthClss">
                            <span>
                              Expiration of Driving License{" "}
                              <span style={{ color: "red" }}>*</span>
                            </span>
                            <DatePicker
                              selected={formData.licenseExpiry}
                              onChange={(date) => {
                                setFormData((prevData) => ({
                                  ...prevData,
                                  licenseExpiry: date,
                                }));
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  licenseExpiry: "",
                                }));
                              }}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="search-input datepicker"
                              minDate={new Date()}
                            />
                            {errors.licenseExpiry && (
                              <span className="error-message">
                                {errors.licenseExpiry}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Submit Button */}
                        <div
                          className="submit-form-btn"
                          onClick={() => {
                            handleNext(); // Proceed to the next step
                          }}
                        >
                          Next
                        </div>
                      </div>
                    )}

                    {step === 2 && (
                      <div className="form-step ">
                        <h6 className="mb-4">Step 2: Rental Details</h6>
                        <div className="row m-0">
                          <label className="col-md-6 mb-3">
                            Last 4 of SSN{" "}
                            <span style={{ color: "red" }}>*</span>
                            <input
                              type="text"
                              name="ssn"
                              value={formData.ssn}
                              maxLength={4}
                              onInput={handleNumbersChange}
                              onChange={(e) => {
                                handleChange(e);
                                if (errors.ssn) {
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    ssn: "",
                                  }));
                                }
                              }}
                              required
                            />
                            {errors.ssn && (
                              <span style={{ color: "red" }}>{errors.ssn}</span>
                            )}
                          </label>
                          <label className="col-md-6 mb-3">
                            Select State <span style={{ color: "red" }}>*</span>
                            <select
                              name="licenseState"
                              value={formData.licenseState || ""}
                              onChange={(e) => {
                                handleChange(e);
                                if (errors.licenseState) {
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    licenseState: "",
                                  }));
                                }
                              }}
                              required
                              style={{
                                backgroundColor: "#fff",
                                height: "42px",
                              }}
                            >
                              <option value="">Select a state</option>
                              {usStates.map((state) => (
                                <option key={state.name} value={state.name}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                            {errors.licenseState && (
                              <span style={{ color: "red" }}>
                                {errors.licenseState}
                              </span>
                            )}
                          </label>

                          <label className="col-md-6 mb-3">
                            <span>
                              Are you approved by any rideshare /
                              delivery platform
                              <span style={{ color: "red" }}>*</span>
                            </span>

                            {/* Radio buttons for Yes/No */}
                            <div
                              className="check_box_mvr"
                              style={{ marginTop: "10px" }}
                            >
                              <input
                                type="radio"
                                id="rideshareApproval"
                                name="rideshareApproval"
                                value="yes"
                                checked={formData.rideshareApproval === "yes"}
                                onChange={(e) => {
                                  handleChange(e);
                                  setErrors((prevErrors) => ({
                                    ...prevErrors,
                                    rideshareApproval: "",
                                  }));
                                }}
                              />
                              <label
                                htmlFor="rideshareApproval"
                                style={{ marginRight: "20px" }}
                              >
                                Yes
                              </label>

                              <input
                                type="radio"
                                id="rideshareApproval"
                                name="rideshareApproval"
                                value="no"
                                checked={formData.rideshareApproval === "no"}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.rideshareApproval) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      rideshareApproval: "",
                                    }));
                                  }
                                }}
                              />
                              <label htmlFor="mvrNo">No</label>
                            </div>
                            {errors.rideshareApproval && (
                              <span style={{ color: "red" }}>
                                {errors.rideshareApproval}
                              </span>
                            )}
                          </label>

                          {formData.rideshareApproval === "yes" && (
                            <label
                              className="col-md-6 mb-3"
                              style={{ marginTop: "5px" }}
                            >
                              <h6
                                style={{
                                  fontSize: "14px",
                                  marginBottom: "0px",
                                }}
                              >
                                Upload Rideshare Approval {"  "}
                                <span
                                  onClick={handleEditClick4}
                                  className="Edit_bttCanvas"
                                >
                                  {isEditing2 ? (
                                    <X size={20} />
                                  ) : (
                                    <Edit size={20} />
                                  )}
                                </span>
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </h6>

                              {!formData.rideshare_aproval_image ||
                              isEditing4 ? (
                                <input
                                  type="file"
                                  name="rideshare_aproval_image"
                                  accept="*/*"
                                  onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                      handleChange(e); // Assuming this handles the state change
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        rideshare_aproval_image: "",
                                      }));
                                    }
                                  }}
                                  required
                                />
                              ) : (
                                // <img className="uplaodDlDIV" src={DLImg + formData.driving_licence_image} alt="Driver's License" />
                                <a
                                  className="uplaodDlDIV"
                                  href={
                                    DLImg + formData.rideshare_aproval_image
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View Rideshare Approval
                                </a>
                              )}
                              {errors.rideshare_aproval_image && (
                                <span style={{ color: "red" }}>
                                  {errors.rideshare_aproval_image}
                                </span>
                              )}
                            </label>
                          )}

                          {formData.rideshareApproval === "yes" && (
                            <label className="col-md-6 mb-3">
                              How many years of passenger-for-hire experience?{" "}
                              <span style={{ color: "red" }}>*</span>
                              <input
                                type="text"
                                name="hireExperience"
                                value={formData.hireExperience}
                                maxLength={2}
                                onInput={handleNumbersChange}
                                onChange={(e) => {
                                  handleChange(e);
                                  if (errors.hireExperience) {
                                    setErrors((prevErrors) => ({
                                      ...prevErrors,
                                      hireExperience: "",
                                    }));
                                  }
                                }}
                                required
                              />
                              {errors.hireExperience && (
                                <span style={{ color: "red" }}>
                                  {errors.hireExperience}
                                </span>
                              )}
                            </label>
                          )}
                          {formData.rideshareApproval === "no" && (
                            <label className="col-md-6 mb-3 usingCarSecDiv">
                              <p className="subLabel">
                                Using car for (Select all that apply){" "}
                                <span style={{ color: "red" }}>*</span>
                              </p>
                              <div>
                                {["Rideshare", "Commute to work", "Other"].map(
                                  (usage) => (
                                    <label key={usage}>
                                      <input
                                        type="checkbox"
                                        name="carUsage"
                                        value={usage}
                                        checked={formData.carUsage.includes(
                                          usage
                                        )}
                                        onChange={(e) => {
                                          handleChange(e);
                                          if (errors.carUsage) {
                                            setErrors((prevErrors) => ({
                                              ...prevErrors,
                                              carUsage: "",
                                            }));
                                          }
                                        }}
                                      />
                                      {usage}
                                    </label>
                                  )
                                )}
                                {formData.carUsage.includes("Other") && (
                                  <input
                                    type="text"
                                    name="carUsageOther"
                                    placeholder="Specify other usage"
                                    defaultValue={formData.carUsageOther}
                                    onChange={handleChange}
                                  />
                                )}
                              </div>
                              {errors.carUsage && (
                                <span style={{ color: "red" }}>
                                  {errors.carUsage}
                                </span>
                              )}
                            </label>
                          )}

                          {formData.rideshareApproval === "yes" && (
                            <label className="col-md-6 mb-3 usingCarSecDiv">
                              <p className="subLabel">
                                Approved and ready to work for (Select all that
                                apply)
                                <span style={{ color: "red" }}>*</span>
                              </p>
                              <div>
                                {["Uber", "GIG Work", "Lyft", "Other"].map(
                                  (platform) => (
                                    <label key={platform}>
                                      <input
                                        type="checkbox"
                                        name="workApproval"
                                        value={platform}
                                        checked={formData.workApproval.includes(
                                          platform
                                        )}
                                        onChange={(e) => {
                                          handleChange(e);
                                          if (errors.workApproval) {
                                            setErrors((prevErrors) => ({
                                              ...prevErrors,
                                              workApproval: "",
                                            }));
                                          }
                                        }}
                                      />
                                      {platform}
                                    </label>
                                  )
                                )}
                                {formData.workApproval.includes("Other") && (
                                  <input
                                    type="text"
                                    name="workApprovalOther"
                                    placeholder="Specify other platform"
                                    value={formData.workApprovalOther}
                                    onChange={handleChange}
                                  />
                                )}
                              </div>
                              {errors.workApproval && (
                                <span style={{ color: "red" }}>
                                  {errors.workApproval}
                                </span>
                              )}
                            </label>
                          )}
                          <label className="col-md-12 mb-3 usingCarSecDiv">
                            <p className="subLabel">
                              When do you need the car?{" "}
                              <span style={{ color: "red" }}>*</span>
                            </p>
                            <div className="radio-group">
                              {[
                                "Within 1-2 days",
                                "Within 2-3 days",
                                "Within 4-7 days",
                              ].map((option) => (
                                <label key={option}>
                                  <input
                                    type="radio"
                                    name="rentalStart"
                                    value={option}
                                    checked={formData.rentalStart
                                      .trim()
                                      .includes(option)}
                                    onChange={(e) => {
                                      handleChange(e);
                                      if (errors.rentalStart) {
                                        setErrors((prevErrors) => ({
                                          ...prevErrors,
                                          rentalStart: "",
                                        }));
                                      }
                                    }}
                                  />
                                  {option}
                                </label>
                              ))}
                            </div>

                            {errors.rentalStart && (
                              <span style={{ color: "red" }}>
                                {errors.rentalStart}
                              </span>
                            )}
                          </label>
                          <h6>Emergency Contact 1</h6>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: "15px",
                            }}
                            className="col-md-12 mb-3 mt-2"
                          >
                            <div className="col-md-3">
                              {" "}
                              <label className="label768">
                                Name
                                <input
                                  type="text"
                                  name="name"
                                  value={formData.emergencyContact1.name || ""}
                                  onChange={(e) => {
                                    if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                      handleEmergencyChange(e, 1);
                                    }
                                  }}
                                />
                                {errors.emergencyContact1_name && (
                                  <span className="error">
                                    {errors.emergencyContact1_name}
                                  </span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-3">
                              {" "}
                              {/* <label className="label768">
                                Relation
                                <input
                                  type="text"
                                  name="relation"
                                  value={
                                    formData.emergencyContact1.relation || ""
                                  }
                                  onChange={(e) => {
                                    if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                      handleEmergencyChange(e, 1);
                                    }
                                  }}
                                />
                                {errors.emergencyContact1_relation && (
                                  <span className="error">
                                    {errors.emergencyContact1_relation}
                                  </span>
                                )}
                              </label> */}
                              <label className="label768">
                                Relation
                                <select
                                  name="relation"
                                  value={formData.emergencyContact1.relation}
                                  onChange={(e) => handleEmergencyChange(e, 1)}
                                >
                                  <option value="" hidden disabled>
                                    Select Relation
                                  </option>
                                  <option value="Father">Father</option>
                                  <option value="Mother">Mother</option>
                                  <option value="Cousin">Cousin</option>
                                  <option value="Spouse">Spouse</option>
                                  <option value="Siblings">Sibling</option>
                                  <option value="Friends">Friend</option>
                                  <option value="Grandparent">
                                    Grandparent
                                  </option>
                                </select>
                                {errors.emergencyContact1_relation && (
                                  <span className="error">
                                    {errors.emergencyContact1_relation}
                                  </span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-3">
                              {" "}
                              <label className="label768">
                                Phone
                                <input
                                  type="tel"
                                  name="phone"
                                  value={formData.emergencyContact1.phone || ""}
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      handleEmergencyChange(e, 1);
                                    }
                                  }}
                                  maxLength={10}
                                />
                                {errors.emergencyContact1_phone && (
                                  <span className="error">
                                    {errors.emergencyContact1_phone}
                                  </span>
                                )}
                              </label>
                            </div>
                          </div>

                          <h6>Emergency Contact 2</h6>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: "15px",
                            }}
                            className="col-md-12 mb-3 mt-2"
                          >
                            <div className="col-md-3">
                              {" "}
                              <label className="label768">
                                Name
                                <input
                                  type="text"
                                  name="name"
                                  value={
                                    formData?.emergencyContact2?.name || ""
                                  }
                                  onChange={(e) => {
                                    if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                      handleEmergencyChange(e, 2);
                                    }
                                  }}
                                />
                                {errors.emergencyContact2_name && (
                                  <span className="error">
                                    {errors.emergencyContact2_name}
                                  </span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-3">
                              {" "}
                              {/* <label className="label768">
                                Relation
                                <input
                                  type="text"
                                  name="relation"
                                  value={
                                    formData?.emergencyContact2?.relation || ""
                                  }
                                  onChange={(e) => {
                                    if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                                      handleEmergencyChange(e, 2);
                                    }
                                  }}
                                />
                                {errors.emergencyContact2_relation && (
                                  <span className="error">
                                    {errors.emergencyContact2_relation}
                                  </span>
                                )}
                              </label> */}
                              <label className="label768">
                                Relation
                                <select
                                  name="relation"
                                  value={formData.emergencyContact2.relation}
                                  onChange={(e) => handleEmergencyChange(e, 2)}
                                >
                                  <option value="" hidden disabled>
                                    Select Relation
                                  </option>
                                  <option value="Father">Father</option>
                                  <option value="Mother">Mother</option>
                                  <option value="Cousin">Cousin</option>
                                  <option value="Spouse">Spouse</option>
                                  <option value="Siblings">Sibling</option>
                                  <option value="Friends">Friend</option>
                                  <option value="Grandparent">
                                    Grandparent
                                  </option>
                                </select>
                                {errors.emergencyContact2_relation && (
                                  <span className="error">
                                    {errors.emergencyContact2_relation}
                                  </span>
                                )}
                              </label>
                            </div>
                            <div className="col-md-3">
                              {" "}
                              <label className="label768">
                                Phone
                                <input
                                  type="tel"
                                  name="phone"
                                  value={
                                    formData?.emergencyContact2?.phone || ""
                                  }
                                  onChange={(e) => {
                                    if (/^\d*$/.test(e.target.value)) {
                                      handleEmergencyChange(e, 2);
                                    }
                                  }}
                                  maxLength={10}
                                />
                                {errors.emergencyContact2_phone && (
                                  <span className="error">
                                    {errors.emergencyContact2_phone}
                                  </span>
                                )}
                              </label>
                            </div>
                            {errors.emergencyContactsame && (
                              <p style={{ color: "red" }}>
                                {errors.emergencyContactsame}
                              </p>
                            )}
                          </div>

                          <h6>
                            Signature{" "}
                            <span
                              onClick={handleEditClick}
                              className="Edit_bttCanvas"
                            >
                              {isEditing ? <X size={20} /> : <Edit size={20} />}
                            </span>{" "}
                          </h6>

                          {(formData && formData.signature_image == null) ||
                          formData.signature_image.trim() === "" ? (
                            <div className="signature-section mt-2 col-md-12 mb-3">
                              <div className="uploadSignature">
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleSignatureUpload}
                                />
                              </div>
                            </div>
                          ) : isEditing ? (
                            <div className="signature-section col-4 mb-3">
                              <div className="uploadSignature">
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleSignatureUpload}
                                />
                              </div>
                            </div>
                          ) : (
                            <img
                              className="sign_imgg"
                              src={SignImg + formData.signature_image}
                              alt="Signature"
                            />
                          )}
                          {/* <img
                              className="sign_imgg"
                              src={SignImg + formData.signature_image}
                              alt="Signature"
                            /> */}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div className="submit-form-btn" onClick={handleBack}>
                            Back
                          </div>

                          <div
                            className="submit-form-btn"
                            onClick={handleNext2}
                          >
                            Next
                          </div>
                        </div>
                      </div>
                    )}

                    {step === 3 && (
                      <div className="form-step">
                        <div className="card mb-4">
                          <div className="card-body">
                            <h5 className="card-title">
                              Agreement for Car Rent, Tolls and Tickets for
                              Rental Vehicle
                            </h5>
                            <div className="form-content">
                              <p>
                                <strong>OWNER:</strong>{" "}
                                {
                                  getApplicationdata.car_data
                                    .registration_company
                                }
                              </p>
                              <p>
                                <strong>RENTER:</strong>{" "}
                                {getApplicationdata.first_name}{" "}
                                {getApplicationdata.last_name}
                              </p>
                              <p>
                                <strong>CAR INFO:</strong>(
                                {carData?.car_tagline || "NA"} / LP#:{" "}
                                {carData?.car_no || "NA"} ) VIN#:{" "}
                                {carData?.vin || "NA"} / Make Year:{" "}
                                {carData?.make_year || "NA"} / Model:{" "}
                                {carData?.model_name || "NA"}
                              </p>
                              <p>
                                I {getApplicationdata.first_name}{" "}
                                {getApplicationdata.last_name}, will be liable
                                and pay Car Rent regularly and for any Tolls /
                                Tickets come on the above rental car from date{" "}
                                Pickup Date to Drop-off Date
                              </p>
                              <p>
                                I acknowledge that I am also liable to pay any
                                all fines, penalties, traffic and/or parking
                                violations, tolls fees, court costs, towing and
                                impound charges, and other expenses relating to
                                the Vehicle assessed for the above period.
                              </p>
                              <p>
                                <strong>IPass Transponder#</strong>{" "}
                                {getApplicationdata.ipass_id}
                              </p>
                              <p>
                                <strong>My Driver License#</strong>{" "}
                                {getApplicationdata.driving_licence}
                              </p>
                              <p>
                                {console.log(
                                  "getApplicationdata",
                                  getApplicationdata
                                )}
                                <strong>Present Residential Address:</strong>{" "}
                                {getApplicationdata.present_map_address}{" "}
                                {getApplicationdata.city}{" "}
                                {getApplicationdata.state}{" "}
                                {getApplicationdata.pin_code}
                              </p>
                              <p>
                                <strong>Phone#:</strong>{" "}
                                {getApplicationdata.mobile_no}
                              </p>
                              <p>
                                <strong>Email:</strong>{" "}
                                {getApplicationdata.email}
                              </p>

                              <div className="form-group custom-control-group">
                                <label className="form-label">
                                  <strong>Agree for Tolls and Ticket*</strong>
                                </label>
                                <div className="custom-control  flexClssApplication">
                                  <input
                                    type="checkbox"
                                    name="tollsTicketAgree"
                                    checked={formState.tollsTicketAgree}
                                    onChange={() => {}}
                                    disabled={isReadOnly}
                                  />
                                  <label className="custom-control-label">
                                    Yes, Agree for Tolls and Ticket
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card mb-4">
                          <div className="card-body">
                            <h5 className="card-title">
                              DISCLOSER AUTHORIZATION FORM
                            </h5>
                            <div className="form-content">
                              <p>
                                <strong>CAR INFO:</strong> (
                                {carData?.car_tagline || "NA"} / LP#:{" "}
                                {carData?.car_no || "NA"} ) VIN#:{" "}
                                {carData?.vin || "NA"} / Make Year:{" "}
                                {carData?.make_year || "NA"} / Model:{" "}
                                {carData?.model_name || "NA"}
                              </p>
                              <p>
                                I {getApplicationdata.first_name}{" "}
                                {getApplicationdata.last_name}, use the
                                above-mentioned vehicle for Rideshare / other
                                platform. I authorize the owner of the Vehicle
                                to obtain information / incident report from my
                                Rideshare / other platform such as, but not
                                limited to {formData.usingCar}
                              </p>
                              <p>
                                <strong>My Phone Number is : </strong>{" "}
                                {getApplicationdata.mobile_no}
                              </p>
                              <p>
                                <strong>Email:</strong>{" "}
                                {getApplicationdata.email}
                              </p>

                              <div className="form-group custom-control-group">
                                <label className="form-label">
                                  <strong>Agree for the Discloser?*</strong>
                                </label>
                                <div className="custom-control flexClssApplication ">
                                  <input
                                    type="checkbox"
                                    name="disclosureAgree"
                                    checked={formState.disclosureAgree}
                                    onChange={() => {}}
                                    disabled={isReadOnly}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="disclosureAgree"
                                  >
                                    Yes, Agree for Discloser
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card mb-4">
                          <div className="card-body">
                            <h5 className="card-title">DO's & DONT's</h5>
                            <div className="form-content">
                              <h6 className="fntWeightlss">DO's</h6>
                              <ul className="dos-list">
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  More than 1/4 tank gas should be always
                                  maintained. If you run out of gas, $90 will be
                                  charged for the Roadside Assistant.
                                </li>
                                <li>
                                  {" "}
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Any new warning sign or driving issues should
                                  be reported immediately and do not keep
                                  driving.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Coming for Bi-weekly Servicing is mandatory.
                                  If you MISS your bi-weekly car service, you
                                  will be responsible for any damage to the
                                  engine or other parts.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Parking and car safety is renter's
                                  responsibility. If you need parking permit or
                                  tags, please make sure you have it on the car.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  If your car is towed away for any reason,
                                  report us immediately. You will have to pay
                                  charges for the towing / impound, etc.
                                </li>
                                <li>
                                  {" "}
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Check Oil and Coolant level once a week.
                                </li>
                              </ul>

                              <h6 className="fntWeightlss">DONT's</h6>
                              <ul className="donts-list">
                                <li>
                                  {" "}
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Cannot leave car running while step out of car
                                  while Pickup / drop offs, filling gas, etc.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Do not leave running Blinkers / fan / radio
                                  etc. when you leave your car as it will drain
                                  the battery. If you drain the Battery, $90
                                  will be charged for the Roadside Assistant.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Cannot leave car keys in the car any time.
                                  Should be always in renter's possession. $90
                                  will be charged for the Roadside Assistant.
                                </li>
                                <li>
                                  {" "}
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />
                                  Cannot allow any other person / family /
                                  friend to operate the rented vehicle.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Do not bring any family members/ kids/ elderly
                                  person with you when you come for car service
                                  due to safety reasons.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Cannot release car to any towing company /
                                  repair shop other than authorized by company.
                                  You will be responsible to the cost.
                                </li>
                                <li>
                                  <CheckCircle
                                    color={"green"}
                                    size={16}
                                    style={{ marginRight: "4px" }}
                                  />{" "}
                                  Cannot keep driving and damage tire and wheel
                                  of the car if there is nail or low air. In the
                                  event of damage renter is responsible for the
                                  cost of repair. $90 will be charged for the
                                  Roadside Assistant.
                                </li>
                              </ul>

                              <div className="form-group custom-control-group">
                                <label className="form-label">
                                  <strong>Agree for Do's & Dont's?*</strong>
                                </label>
                                <div className="custom-control flexClssApplication">
                                  <input
                                    type="checkbox"
                                    name="dosAndDontsAgree"
                                    checked={formState.dosAndDontsAgree}
                                    onChange={() => {}}
                                    disabled={isReadOnly}
                                  />
                                  <label className="custom-control-label">
                                    Yes, Agree for Do's & Dont's
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card mb-4">
                          <div className="card-body">
                            <h5 className="card-title">
                              Parking & Roadside Assistance
                            </h5>
                            <div className="form-content">
                              <div className="form-group">
                                <label className="form-label">
                                  <strong>Where will you Park car?*</strong>
                                </label>
                                <div>
                                  <div className="custom-radio-group">
                                    {[
                                      "Parking Lot - Need Tag or Sticker",
                                      "Parking Lot - No Need Tag or Sticker",
                                      "Street Parking",
                                      "Drive-way",
                                      "Private Garage",
                                      "Other",
                                    ].map((option) => (
                                      <div
                                        className="custom-control custom-radio flexClssApplication marginBttmClss"
                                        key={option}
                                      >
                                        <input
                                          type="checkbox"
                                          id={option.replace(/\s+/g, "")}
                                          name="parkingOption"
                                          value={option}
                                          className="custom-control-input"
                                          checked={formState.parkingOption.includes(
                                            option
                                          )}
                                          onChange={handleChange2}
                                          disabled={isReadOnly}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={option.replace(/\s+/g, "")}
                                        >
                                          {option}
                                        </label>
                                      </div>
                                    ))}
                                    {formErrors.parkingOption && (
                                      <span className="error-message">
                                        {formErrors.parkingOption}
                                      </span>
                                    )}
                                  </div>
                                  <div className="col-6">
                                    {" "}
                                    {formState.parkingOption.includes(
                                      "Other"
                                    ) && (
                                      <div className="custom-input-group">
                                        <label htmlFor="otherParkingOption">
                                          Please specify your parking option:
                                        </label>
                                        <input
                                          className="form-control "
                                          type="text"
                                          id="otherParkingOption"
                                          name="otherParkingOption"
                                          defaultValue={
                                            formState.otherParkingOption
                                          }
                                          onChange={handleChange2}
                                          placeholder="Enter your parking option"
                                          readOnly={isReadOnly}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group mt-4">
                                <label className="form-label">
                                  <strong>
                                    Recommended AAA Road Side Assistant.*
                                  </strong>
                                </label>
                                <div className="custom-radio-group">
                                  {[
                                    "I have AAA",
                                    "May decide later. (Your will be responsible to any Roadside Assistant : need for Jump / putting Donut / locked out etc. It may be available through Uber/Lyft or otherwise)",
                                  ].map((option) => {
                                    const optionId = option
                                      .substring(0, 10)
                                      .replace(/\s+/g, "");
                                    return (
                                      <div
                                        className="custom-control custom-radio flexClssApplication marginBttmClss"
                                        key={optionId}
                                      >
                                        <input
                                          type="radio"
                                          id={optionId}
                                          name="roadsideAssistant"
                                          value={option}
                                          className="custom-control-input"
                                          checked={
                                            formState.roadsideAssistant ===
                                            option
                                          }
                                          onChange={(e) => {
                                            setFormState((prev) => ({
                                              ...prev,
                                              roadsideAssistant: e.target.value,
                                            }));
                                            console.log(
                                              "option",
                                              e.target.value
                                            );
                                          }}
                                        />
                                        <CheckCircle
                                          color={
                                            formState.roadsideAssistant ===
                                            option
                                              ? "green"
                                              : "gray"
                                          }
                                          size={16}
                                          style={{ marginRight: "4px" }}
                                        />
                                        <label
                                          className="custom-control-label"
                                          htmlFor={optionId}
                                        >
                                          {option}
                                        </label>
                                      </div>
                                    );
                                  })}
                                  {formErrors.roadsideAssistant && (
                                    <span className="error-message">
                                      {formErrors.roadsideAssistant}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card mb-4">
                          <div className="card-body">
                            <h5 className="card-title">
                              Agreement of Terms and Condition for Car Insurance
                            </h5>
                            <div className="form-content">
                              <p>
                                <strong>Company / Car Owner:</strong>{" "}
                                {
                                  getApplicationdata.car_data
                                    .registration_company
                                }
                              </p>
                              <p>
                                <strong>Address:</strong>{" "}
                                {getApplicationdata.company_address}
                              </p>
                              <p>
                                <strong>Driver:</strong>{" "}
                                {getApplicationdata.first_name}{" "}
                                {getApplicationdata.last_name}
                              </p>
                              <p>
                                <strong>DL #:</strong>{" "}
                                {getApplicationdata.driving_licence}
                              </p>
                              <p>
                                <strong>Insurance Policy#:</strong>{" "}
                                {getApplicationdata?.insurance_policy || "NA"}
                              </p>
                              <p>
                                <strong>Car:</strong>{" "}
                                {carData?.car_name || "NA"}
                              </p>
                              <p>
                                <strong>VIN:</strong> {carData?.vin || "NA"}
                              </p>
                              <p>
                                <strong>Insurance Issue date</strong>{" "}
                                {getApplicationdata.from_date}
                              </p>
                              <p>
                                The above company/owner will be lien Holder /
                                Lessor/ additional interest and loss payee for
                                the above policy. Any Refund at the time of
                                cancellation or payments will be directly sent
                                to the company / Owner.
                              </p>

                              <div className="form-group custom-control-group">
                                <label className="form-label">
                                  <strong>
                                    Agreement for Terms and Condition for Car
                                    Insurance*
                                  </strong>
                                </label>
                                <div className="custom-control flexClssApplication">
                                  <input
                                    type="checkbox"
                                    id="insuranceAgree"
                                    name="insuranceAgree"
                                    checked={formState.insuranceAgree}
                                    onChange={() => {}}
                                    disabled={isReadOnly}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="insuranceAgree"
                                  >
                                    Accept
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="submit-form-btn"
                            onClick={handleBack}
                          >
                            Back
                          </button>
                          <div
                            className="submit-form-btn"
                            onClick={() => {
                              const { isValid } = handleCatchError3();
                              if (isValid) {
                                handleNext();
                              }
                            }}
                          >
                            Next
                          </div>
                        </div>
                      </div>
                    )}

                    {step === 4 && (
                      <div className="form-step">
                        <h2 className="forOcHead">FOR OFFICE USE ONLY</h2>

                        <div className="card mb-4">
                          <div className="card-body">
                            <h5 className="card-title">Payment Terms</h5>
                            <div className="form-content">
                              <div className="custom-radio-group">
                                <p>
                                  <strong>Car Rent:</strong> ${carData.Price}
                                  {/* $55 */}
                                </p>

                                <p>
                                  <strong>Payment Cycle:</strong>
                                </p>

                                <div className="custom-control custom-radio flexClssApplication">
                                  <input
                                    type="radio"
                                    id="daily"
                                    name="paymentCycle"
                                    value="Daily"
                                    className={`custom-control-input ${
                                      formErrors.day_weekly ? "error-input" : ""
                                    }`}
                                    checked={formState.day_weekly == "Daily"}
                                    onChange={(e) =>
                                      setFormState({
                                        ...formState,
                                        day_weekly: e.target.value,
                                      })
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="daily"
                                  >
                                    Daily
                                  </label>
                                </div>

                                <div className="custom-control custom-radio flexClssApplication">
                                  <input
                                    type="radio"
                                    id="weekly"
                                    name="paymentCycle"
                                    value="Weekly"
                                    className={`custom-control-input ${
                                      formErrors.day_weekly ? "error-input" : ""
                                    }`}
                                    checked={formState.day_weekly == "Weekly"}
                                    onChange={(e) =>
                                      setFormState({
                                        ...formState,
                                        day_weekly: e.target.value,
                                      })
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="weekly"
                                  >
                                    Weekly
                                  </label>
                                </div>
                                {formErrors.day_weekly && (
                                  <span className="error-message">
                                    {formErrors.day_weekly}
                                  </span>
                                )}
                              </div>

                              <div className="form-group mt-3 col-md-6">
                                <label htmlFor="surcharges">
                                  <strong>Recieved Deposit Amount: </strong>
                                  <span
                                    className="mt-2 text-muted"
                                    style={{ fontWeight: "600" }}
                                  >
                                    ${paiddepositFirst}
                                  </span>
                                  {/* first_time_paid_deposit */}
                                </label>
                                <span className="mt-2 text-muted small">
                                  (Deposit is paid by the driver or carried
                                  forward from the last booking. See account
                                  ledger for details.)
                                </span>
                              </div>

                              <div className="row">
                                <div className="form-group mt-3 col-lg-3 col-md-6">
                                  <label htmlFor="surcharges">
                                    <strong>Surcharges:</strong>
                                  </label>
                                  <div
                                    className="d-flex align-items-end"
                                    style={{ position: "relative" }}
                                  >
                                    <input
                                      type="number"
                                      id="surcharges"
                                      name="surcharges"
                                      className="form-control"
                                      style={{
                                        // width: "40%",
                                        paddingLeft: "30px",
                                      }}
                                      placeholder="Enter surcharge amount"
                                      defaultValue={surcharges}
                                      onChange={(e) =>
                                        Setsurcharges(e.target.value)
                                      }
                                      readOnly={isReadOnly}
                                    />
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        marginLeft: "0.5rem",
                                      }}
                                    >
                                      /day
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        marginLeft: "0.5rem",
                                        position: "absolute",
                                        top: "15px",
                                        left: "5px",
                                      }}
                                    >
                                      $
                                    </span>
                                  </div>
                                  {/* {formErrors.surcharges && (
    <span className="error-message">{formErrors.surcharges}</span>
  )} */}
                                </div>
                                <div className="form-group mt-3 col-lg-3 col-md-6">
                                  <label htmlFor="surcharges">
                                    <strong>Deposit Amount: </strong>
                                    {/* <span className="mt-2 text-muted small">
                                      (Deposit amount is $250)
                                    </span> */}
                                  </label>
                                  <div
                                    className="d-flex align-items-end"
                                    style={{ position: "relative" }}
                                  >
                                    <input
                                      type="number"
                                      id="deposit"
                                      name="deposit"
                                      className={`form-control ${
                                        formErrors.deposit_value
                                          ? "error-input"
                                          : ""
                                      }`}
                                      style={{
                                        // width: "40%",
                                        paddingLeft: "30px",
                                      }}
                                      placeholder="Enter Deposit amount"
                                      defaultValue={deposit}
                                      onChange={(e) => {
                                        const newValue = e.target.value;

                                        mmtry(newValue, 1);
                                      }}
                                      readOnly={isReadOnly}
                                    />
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        marginLeft: "0.5rem",
                                        position: "absolute",
                                        top: "15px",
                                        left: "5px",
                                      }}
                                    >
                                      $
                                    </span>
                                  </div>
                                  {formErrors.deposit_value && (
                                    <span className="error-message">
                                      {formErrors.deposit_value}
                                    </span>
                                  )}
                                </div>
                                <div className="form-group mt-3 col-lg-3 col-md-6">
                                  <label htmlFor="surcharges">
                                    <strong>Paid Deposit:</strong>
                                  </label>
                                  <div
                                    className="d-flex align-items-end"
                                    style={{ position: "relative" }}
                                  >
                                    <input
                                      type="text"
                                      id="deposit"
                                      name="deposit"
                                      className={`form-control ${
                                        formErrors.paid_deposit
                                          ? "error-input"
                                          : ""
                                      }`}
                                      style={{
                                        // width: "40%",
                                        paddingLeft: "30px",
                                      }}
                                      placeholder="Enter Deposit amount"
                                      defaultValue={
                                        paiddepositFirst == 250
                                          ? paiddepositFirst
                                          : paiddeposit
                                      }
                                      // onChange={(e) => handlepaiddeposit(e)}
                                      onChange={(e) => {
                                        mmtry(e.target.value, 2);
                                        // Setduedeposit(
                                        //   deposit -
                                        //     paiddepositFirst -
                                        //     e.target.value
                                        // );

                                        // let totalduedeposit =
                                        //   deposit -
                                        //   paiddepositFirst -
                                        //   e.target.value;
                                        // if (totalduedeposit < 0) {
                                        //   setFormErrors((prevErrors) => ({
                                        //     ...prevErrors,
                                        //     due_deposit:
                                        //       "Due Deposit amount cannot be in negative.",
                                        //   }));
                                        // }
                                      }}
                                      inputMode="decimal"
                                      disabled={
                                        paiddepositFirst == 250 ? true : false
                                      }
                                    />
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        marginLeft: "0.5rem",
                                        position: "absolute",
                                        top: "15px",
                                        left: "5px",
                                      }}
                                    >
                                      $
                                    </span>
                                  </div>
                                  {/* <p className="mt-2 text-muted small">
                                  Deposit amount is $250
                                </p> */}
                                  {formErrors.paid_deposit && (
                                    <span className="error-message">
                                      {formErrors.paid_deposit}
                                    </span>
                                  )}
                                </div>
                                <div className="form-group mt-3 col-lg-3 col-md-6">
                                  <label htmlFor="surcharges">
                                    <strong>Due Deposit:</strong>
                                  </label>
                                  <div
                                    className="d-flex align-items-end"
                                    style={{ position: "relative" }}
                                  >
                                    <input
                                      type="number"
                                      id="deposit"
                                      name="deposit"
                                      className="form-control"
                                      style={{
                                        // width: "40%",
                                        paddingLeft: "30px",
                                      }}
                                      placeholder="Enter Deposit amount"
                                      value={duedeposit || 0}
                                      onChange={(e) => {
                                        mmtry(e.target.value, 3);
                                      }}
                                      readOnly
                                    />
                                    <span
                                      style={{
                                        fontSize: "16px",
                                        marginLeft: "0.5rem",
                                        position: "absolute",
                                        top: "15px",
                                        left: "5px",
                                      }}
                                    >
                                      $
                                    </span>
                                  </div>
                                  {formErrors.due_deposit && (
                                    <span className="error-message">
                                      {formErrors.due_deposit}
                                    </span>
                                  )}
                                  {/* <p className="mt-2 text-muted small">
                                  Deposit amount is $250
                                </p> */}
                                </div>
                              </div>

                              <div className="form-group mt-4">
                                <label className="form-label">
                                  <strong>How user paid?*</strong>
                                </label>
                                <div className="custom-radio-group">
                                  {[
                                    "Cash",
                                    "Online (Credit/Debit Card)",
                                    "Zelle",
                                  ].map((option) => (
                                    <div
                                      className="custom-control custom-radio flexClssApplication"
                                      key={option}
                                    >
                                      <input
                                        type="radio"
                                        id={option.replace(/\s+/g, "")}
                                        name="paymentOption"
                                        value={option}
                                        className="custom-control-input"
                                        checked={
                                          formState.paymentOption === option
                                        }
                                        onChange={handleChange2}
                                        disabled={isReadOnly}
                                      />
                                      <label
                                        className="custom-control-label"
                                        htmlFor={option.replace(/\s+/g, "")}
                                      >
                                        {option}
                                      </label>
                                    </div>
                                  ))}
                                  {formErrors.paymentOption && (
                                    <span className="error-message">
                                      {formErrors.paymentOption}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="submit-form-btn"
                            onClick={handleBack}
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            className="submit-form-btn"
                            onClick={handleSubmit}
                            // disabled={isReadOnly}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditApplicationFormPage;
